export const ourDomains = [
	'0.0.0.0',
	'localhost',
	'127.0.0.1',
	'interactr-app.vercel.app',
	'interactrapp.com',
	'www.interactrapp.com'
];